module.exports = __webpack_public_path__ + "a4dbbaacce72e299f3ef02e977495806.eot";


//////////////////
// WEBPACK FOOTER
// ./css/fonts/ComicNeue/ComicNeue-Angular-Light-Oblique.eot
// module id = 395
// module chunks = 0